import { Component } from '@angular/core';
import {DeviceModel} from "../../../models/grit/grit.device-model";
import {GritUserService, MailingList} from "../../../services/grit/grit.user.service";
import {BsModalRef} from "ngx-bootstrap/modal";
import {clone} from "lodash";
import {UiBlockService} from "../../../services/ui-block.service";

@Component({
  selector: 'app-mailing-list',
  templateUrl: './mailing-list.component.html',
  styleUrls: ['./mailing-list.component.scss','../../../app.component.scss'],
  standalone: false
})
export class MailingListComponent {

  mailingList : MailingList[];
  selectedList: number;
  selectedEntry : {
    iList: number,
    i: number,
    entry: {
      name:string,
      email:string
    }
  } = null;


  constructor(
    protected gritUserService : GritUserService,
    public bsModalRef : BsModalRef,
    private uiBlock: UiBlockService,
  ) {
    this.mailingList = clone(gritUserService.profile.mailingList);
  }

  validateName(name:string){return new RegExp(/^[a-z0 -9À-ÿ]{1,32}$/gi).test(name)}
  validateEmail(email:string){return new RegExp(GritUserService.EMAIL_REGEX).test(email)}


  addList(name: string){
    if (this.validateName(name)){
      this.selectedList = this.mailingList.push({name:name, list: []}) - 1;
    }
    return
  }

  deleteList(){
    this.mailingList.splice(this.selectedList, 1);
    this.selectedList = null;
  }

  addEntry(iList: number,name: string, email: string) {
    if (this.validateName(name) && this.validateEmail(email)){
      this.mailingList[iList].list.push({name:name, email:email});
    }
  }

  editEntry(iList:number, i:number){
    if (this.selectedEntry?.iList == iList && this.selectedEntry?.i == i){
      if (this.validateName(this.selectedEntry.entry.name) && this.validateEmail(this.selectedEntry.entry.email)){
        this.mailingList[iList].list[i] = {name: this.selectedEntry.entry.name, email: this.selectedEntry.entry.email};
      }
      this.selectedEntry = null;
      return;
    }

    this.selectedEntry = {
      iList: iList,
      i: i,
      entry: clone(this.mailingList[iList].list[i])
    }
  }

  deleteEntry(iList:number, i:number){
    this.mailingList[iList].list.splice(i, 1);
    // this.selectedEntry = {
    //   iList: iList,
    //   i: i,
    //   entry: this.mailingList[iList].list[i]
    // }
  }


  async save(){
    this.uiBlock.startBlock("Saving mailing list...")
    this.gritUserService.profile.mailingList = clone(this.mailingList);
    await this.gritUserService.updateProfileMailingList();
    this.uiBlock.stopBlock()

    this.bsModalRef.hide();
  }

  cancel(){
    this.bsModalRef.hide();
  }

  protected readonly DeviceModel = DeviceModel;
  protected readonly String = String;
  protected readonly Boolean = Boolean;
  protected readonly Number = Number;
}
